import { IApplicationState } from '../../types/redux';

export const getHasMore = (state: IApplicationState): boolean => {
  return state.reviews.hasMore;
};
